export default "__VITE_ASSET__CXRVTnma__"